<template>
  <div class="caikuangExchangeList">
    <div class="exchange-list">
        <div class="exchange-title" v-if="from=='home'">彩矿兑换</div>
        <div class="exchange-tab">
            <van-tabs  class="institutional-van-tabs" @click="on_change" :ellipsis="false">
                <van-tab v-for="(item,index) in institutional" :key="index">
                    <template #title > {{item}} </template>
                    <van-list
                    finished-text="没有更多了"
                    @load="onLoad"
                    >
                    <div class="exchange-tab-list-all" v-if="from=='home'">
                        <van-cell v-for="(item,indexs) in list" :key="indexs">
                            <div class="list-name-title" v-if="item.limit_role"><span>{{item.limit_role==1?'总督':item.limit_role==2?'提督':item.limit_role==3?'舰长':item.limit_role==9?'粉丝团':''}}限定</span></div>

                            <div class="exchange-tab-list-ul">
                                <div class="list-name">{{item.name}}</div>
                                <div class="list-biaoqian">
                                  <span class="list-tip">{{item.expire == 0 ? '永久' : `${Math.floor(item.expire/60/60/24)}天`}}</span>
                                  <span class="list-tip">{{item.category}}</span>
                                </div>
                                <div class="list-foot">
                                    <span class="list-foot-1" v-if="from=='home'">{{item.price}}彩矿</span>
                                    <span  v-if="!item.is_owned">
                                      <span class="list-foot-2" style="display: inline-block;" v-if="item.can_buy" @click="on_exchange(item.id)">兑换</span>
                                      <span v-else class="list-foot-2-1">兑换</span>
                                    </span>
                                    <span v-else>兑换上限({{item.have_num}}/{{item.limit_num}})</span>
                                </div>
                            </div>
                        </van-cell>
                    </div>
                    <div class="exchange-tab-list-all" v-else>
                        <van-cell v-for="(item,indexs) in list" :key="indexs">
                            <div class="exchange-tab-list-ul">
                                <div class="list-name">{{item.item.name}} </div>
                                <div class="list-biaoqian">
                                  <!-- <span class="list-tip">{{item.item.category}}</span> -->

                                  <span class="list-tip" v-if="item.item.stacked == 1" >数量:{{item.num}}</span>
                                  <span class="list-tip">有效期:{{item.expired === 0 ? '永久' : getData(item.expired)}}</span>
                                </div>
                                <div class="list-foot" v-if="item.item.active_limit < 2">
                                    <span class="list-foot-2" v-if="!item.is_active" @click="on_startUse(item.id)">立即装备</span>
                                    <span class="list-foot-3" v-else @click="on_startNoUse(item.id)">取消装备</span>
                                </div>
                                <div class="list-foot" v-else>
                                  <span class="list-foot-4">发送弹幕 G{{item.item.id}} 使用</span>
                                </div>
                            </div>
                        </van-cell>
                    </div>
                    </van-list>
                </van-tab>
            </van-tabs>
        </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tab, Tabs, List, Toast, Dialog } from 'vant'
import { post } from './../../../utils/httpService'
Vue.use(List)
Vue.use(Tab)
Vue.use(Tabs)
export default {
  name: 'caikuangExchangeList',
  data () {
    return {
      // list: [],
      // loading: false,
      // finished: false,
      // institutional: ['皮肤', '皮肤', '皮肤', '皮肤', '皮肤', '皮肤', '皮肤', '皮肤'
      // ]
      // listAll: [],
    }
  },
  props: {
    from: {type: String, default: 'home'},
    list: {type: Array, default: () => []},
    userInfoObj: {type: Object, default: () => {}},
    institutional: {type: Array, default: () => []}
  },
  created () {

  },
  methods: {
    on_change (index) {
      console.log(index)
      let catName = this.institutional.filter((item, i) => {
        if (i === index) {
          return item
        }
      })
      this.$emit('catNameFnc', catName[0])
    },
    onLoad () {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      // debugger
      // setTimeout(() => {
      //   // for (let i = 0; i < 10; i++) {
      //   //   this.list.push(this.list.length + 1)
      //   // }

      //   // 加载状态结束
      //   this.loading = false

      //   // 数据全部加载完成
      //   if (this.list.length >= 2) {
      //     this.finished = true
      //   }
      // }, 1000)
      this.finished = true
    },
    getData (n) {
      n = new Date(Number(n) * 1000)
      return n.toLocaleDateString().replace(/\//g, '-') + ' '
    },
    async on_exchange (id) {
      let exchange = await post('/api/shop/item/exchange', {item_id: id})
      if (exchange === 'ok') {
        // Toast('兑换成功！请前往我的道具进行使用！')
        Dialog.alert({
          message: '兑换成功！请前往"我的道具"进行装备！'
        }).then(() => {
          window.location.reload()
        })
        this.list.map(item => {
          if (item.id === id) {
            item.is_owned = true
          }
        })
      }
      console.log(exchange)
    },
    async on_startUse (id) {
      let exchange = await post('/api/user/item/active', {item_id: id})
      if (exchange === 'ok') {
        Toast('使用成功！')
        this.list.map(item => {
          if (item.id === id) {
            item.is_active = true
          }
        })
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      }
    },
    async on_startNoUse (id) {
      let exchange = await post('/api/user/item/deactive', {item_id: id})
      if (exchange === 'ok') {
        Toast('取消成功！')
        this.list.map(item => {
          if (item.id === id) {
            item.is_active = false
          }
        })
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      }
    }

  }
}
</script>

<style>
.exchange-list{padding:0.4rem 0.22rem;}
.exchange-title{font-size: 0.32rem;font-weight: bold;}
.institutional-van-tabs{font-size: 0.26rem;margin-top: 0.3rem;}
.institutional-van-tabs  .van-tabs__wrap{height: 0.5rem;}
.institutional-van-tabs  .van-tabs__line{background: #3760F4;height: 0px;}
.institutional-van-tabs  .van-tab{margin-right:40px;padding: 0;font-size:0.25rem;color: #222222;background: #f3f2f2;height: 0.44rem;padding:0.22rem 0.24rem;color: #777;border:1px solid #eee;margin-right: 0.2rem;border-radius: 2px;}
.institutional-van-tabs  .van-tab--active{color: #222222;background: #fff;border:1px solid #222222}
.institutional-van-tabs .van-tabs__content{margin-top: 0.15rem;}
/* .institutional-van-tabs .van-tab{padding: 0.22rem 0;} */
.van-cell__value{padding: 10px 16px !important;}
.exchange-tab-list-all{display: flex;flex-wrap: wrap;justify-content: space-between;margin-top: 0.3rem;}
.exchange-tab-list-all .van-cell{width: 48%;margin-bottom: 0.2rem;box-shadow: 0 1px 10px hsl(0deg 0% 0% / 0.075); min-height: 2.2rem;padding: 0;}
.exchange-tab-list-ul{height: 100%;display: flex;flex-direction: column;justify-content: space-between;}
.list-name{font-weight: bold;color: #333;}
.list-name-title{position: absolute;font-size: 12px;right: 0px;top: -1px;}
.list-name-title span{background: rgba(254, 99, 10, 0.6);color: #fff;padding:4px 6px;border-bottom-left-radius: 8px;border-top-right-radius: 8px;}
.list-biaoqian{padding: 0.1rem 0;}
.list-biaoqian > span:nth-child(1){margin-right: 5px;}
.list-tip{color: rgba(238, 183, 2, 0.668);border: 1px solid rgba(238, 183, 2, 0.668);padding: 0.04rem 0.1rem;font-size: 12px;}
.list-foot{display: flex;justify-content: space-between;}
.list-foot-1{color: rgba(238, 183, 2, 0.668);font-weight: bold;cursor: pointer;}
.list-foot-2{background: #000;color: #fff;padding: 0 0.1rem;cursor: pointer;}
.list-foot-2-1{background: #ccc;color: #fff;padding: 0 0.1rem;display: inline-block}
.list-foot-3{background: rgba(238, 183, 2, 0.668);padding: 0 0.1rem;color: #fff;cursor: pointer;}
.list-foot-4{background: rgba(80, 81, 80, 0.668);padding: 0 0.1rem;color: #fff;}
</style>



// WEBPACK FOOTER //
// src/view/home/components/caikuangExchangeList.vue